<template>
    <div class="ChatMessage" ref="oneBlock">
        <div class="ChatMessage__in">
            <AAvatar
                width="50"
                :src="data.img.src"
                :alt="data.img.alt"
                :title="data.img.title"
                class="ChatMessage__avatar"/>
            <div class="ChatMessage__msg">
                <div>
                    <span class="ChatMessage__name">{{ data.name }}</span>
                    <span class="ChatMessage__time">{{showDate}}</span>
                </div>
                <div class="ChatMessage__text">
                  <div v-html="data.text"></div>
                  <div v-if="data?.files?.length>0">
                    <FileMessage v-for="file in data.files" :fileInfo="file"/>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import each from 'lodash/each'
import {AAvatar} from "../ui";
import FileMessage from "./FileMessage.vue";

export default {
    name: "Message",
    props: {
        data: {
            type: Object,
            validator(val) {
                let valid = true;
                each(['img', 'name', 'time', 'text'], key => {
                    if (Object.keys(val).includes(key) === false) {
                        valid = false
                    }
                })
                return valid
            }
        },
        id:{
            type: Number,
        }
    },
    data() {

        return {
          bxObject:null,
          sended:this.data.watched
        }
    },
    components: {
        AAvatar,
      FileMessage
    },
    computed:{
        showDate() {
          let t = '';
          if(this.bxObject&&this.data.time) {
            t = this.bxObject.date.format("x",this.data.time);
          }

          return  t;
        }
    },
    mounted() {

      this.bxObject = BX;
      if(!this.sended) {
          if(testVisibleBlock(this.$refs['oneBlock'])) {
              this.$emit('watched',this.id);
              this.sended = true;
          }
          window.addEventListener('scroll', () => {
              if(testVisibleBlock(this.$refs['oneBlock'])&&!this.sended) {
                  this.$emit('watched',this.id);
                  this.sended = true;
              }
          });
          let parentWithClass = this.$refs['oneBlock'].closest('.ChatWindow__in');
          parentWithClass.addEventListener('scroll', () => {
              if(testVisibleBlock(this.$refs['oneBlock'])&&!this.sended) {
                  this.$emit('watched',this.id);
                  this.sended = true;
              }
          });
      }



    }
}
</script>

<style scoped lang="scss">
.ChatMessage {
    width: 100%;
    padding: rem(15) 0;
    margin-bottom: rem(15);

    &__in {
        display: flex;
        gap: rem(16);
    }

    &__avatar {
        transform: translateY(rem(-10));
    }

    &__name {
        font-weight: 600;
        font-size: rem(14);
        line-height: rem(19);
        margin-right: rem(5);
    }

    &__time {
        font-weight: 600;
        font-size: rem(14);
        line-height: rem(19);
        color: var(--c-gray-500)
    }

    &__msg {
        max-width: calc(100% - 70px);
    }

    &__text {
        padding-top: rem(10);
        font-weight: 400;
        font-size: rem(16);
        line-height: rem(24);
    }
}
</style>